const coins = {
  // User coins page
  pageTitle: 'Coins',
  pageSubtitle: 'Your coin balance and transaction history',
  balance: 'Coin balance',
  balanceUnit: 'coins',
  rateNote: '1 coin = {{rate}} SAR',
  signInToView: 'Sign in to view your coins',
  loadError: 'Failed to load your coins',

  // Compact badge
  badgeLabel: '{{count}} coins',

  // History table
  historyTitle: 'Transaction history',
  historyEmpty: 'You have no coin transactions yet.',
  colDate: 'Date',
  colType: 'Type',
  colReason: 'Reason',
  colAmount: 'Amount',
  colBalance: 'Balance',
  filterAllTypes: 'All types',
  prev: 'Previous',
  next: 'Next',
  pageOf: 'Page {{page}} of {{totalPages}}',

  // Transaction type labels (CoinTxnType)
  type: {
    PLAN_GRANT: 'Plan grant',
    ADMIN_CREDIT: 'Admin credit',
    ADMIN_DEBIT: 'Admin deduction',
    PURCHASE_SPEND: 'Purchase',
    DISCOUNT_REDEEM: 'Discount redeemed',
    REFUND_CREDIT: 'Refund',
    ADJUSTMENT: 'Adjustment',
  },

  // Plan cards
  includesCoins: 'Includes {{count}} coins',
  equalsCoins: '= {{count}} coins',

  // Admin console
  admin: {
    title: 'Coins',
    subtitle: 'Manage the coin rate and user balances',

    // Rate editor (SUPER_ADMIN only)
    rateTitle: 'Coin exchange rate',
    rateSubtitle: 'Set how many Saudi Riyals one coin is worth.',
    currentRate: 'Current rate',
    rateValue: '{{rate}} SAR per coin',
    rateLabel: 'SAR per coin',
    rateHint: 'Must be greater than zero.',
    saveRate: 'Save rate',
    rateSaved: 'Coin rate updated successfully',
    rateError: 'Failed to update the coin rate',
    rateInvalid: 'Enter a rate greater than zero',
    superAdminOnly: 'Only super admins can change the coin rate.',

    // Grant / deduct
    grantTitle: 'Grant or deduct coins',
    grantSubtitle: 'Credit or debit a specific user\'s coin balance.',
    fieldUserId: 'User ID',
    fieldUserIdHint: 'The ID of the user to adjust.',
    fieldAmount: 'Amount',
    fieldDirection: 'Direction',
    directionCredit: 'Credit (add)',
    directionDebit: 'Deduct (remove)',
    fieldReason: 'Reason',
    fieldReasonHint: 'Recorded in the audit log and the user\'s ledger.',
    submit: 'Apply',
    submitting: 'Applying...',
    grantSuccess: 'Coins updated. New balance: {{balance}}',
    grantError: 'Failed to update coins',
    amountInvalid: 'Enter an amount greater than zero',
    userIdRequired: 'Enter a user ID',
    reasonRequired: 'Enter a reason',

    // User ledger panel
    ledgerTitle: 'User balance & ledger',
    ledgerBalance: 'Current balance',
    ledgerEmpty: 'No transactions for this user yet.',
    loadUser: 'Look up',
    loadUserError: 'Failed to load this user\'s coins',
  },
};

export default coins;
